import React from 'react';
import { Link } from 'react-router-dom';
import ArticleLayout from '../components/ArticleLayout';
import { FANOUT_PAGES } from '../lib/site';

const page = FANOUT_PAGES.find((p) => p.path === '/mini-mental-e-teste-do-relogio');

const ANSWER =
  'O Mini Mental e o teste do relógio são frequentemente aplicados juntos porque cobrem áreas complementares: o Mini Mental explora orientação, memória, atenção e linguagem, enquanto o teste do relógio aprofunda função executiva e organização visuoespacial — domínios que o Mini Mental avalia pouco. Juntos, oferecem um panorama mais completo em poucos minutos adicionais de aplicação.';

const REFERENCES = [
  'Sunderland T, Hill JL, Mellow AM, et al. Clock drawing in Alzheimer’s disease: a novel measure of dementia severity. J Am Geriatr Soc. 1989;37(8):725-9.',
  'Folstein MF, Folstein SE, McHugh PR. "Mini-mental state": a practical method for grading the cognitive state of patients for the clinician. J Psychiatr Res. 1975;12(3):189-98.'
];

const RELATED = [
  {
    to: '/mini-mental-ou-moca',
    label: 'Mini Mental ou MoCA',
    note: 'outra opção de rastreio mais abrangente que combina domínios semelhantes.'
  },
  {
    to: '/escolaridade',
    label: 'Mini Mental por escolaridade',
    note: 'a mesma cautela de interpretação vale para instrumentos combinados.'
  }
];

export default function MiniMentalETesteDoRelogio() {
  return (
    <ArticleLayout page={page} answer={ANSWER} related={RELATED} references={REFERENCES}>
      <section aria-labelledby="o-que-cada-um-cobre">
        <h2 id="o-que-cada-um-cobre" className="text-2xl mb-5">O que cada instrumento cobre que o outro não cobre?</h2>
        <p className="text-[var(--text-muted)]">
          O Mini Mental tem maior peso em orientação temporal e espacial, registro, atenção e
          linguagem — áreas em que uma pontuação alta é comum mesmo em pessoas com alterações
          executivas leves. O teste do relógio exige planejamento, organização espacial e execução
          de um comando complexo em uma única tarefa integrada, capturando dificuldades que passam
          despercebidas no Mini Mental isoladamente.
        </p>
      </section>

      <section aria-labelledby="resultados-discordantes">
        <h2 id="resultados-discordantes" className="text-2xl mb-5">Como interpretar resultados discordantes entre os dois?</h2>
        <p className="text-[var(--text-muted)]">
          Um Mini Mental dentro do esperado combinado com um teste do relógio alterado é um padrão
          clinicamente relevante: sugere que a dificuldade está concentrada em função executiva e
          organização, e não nas áreas mais exploradas pelo Mini Mental. Esse padrão de
          discordância não deve ser descartado — é, com frequência, exatamente o tipo de achado
          que motiva investigação adicional. O inverso também ocorre e igualmente merece atenção
          ao contexto clínico completo.
        </p>
      </section>

      <section aria-labelledby="quando-combinar">
        <h2 id="quando-combinar" className="text-2xl mb-5">Em que situações essa combinação é mais útil?</h2>
        <p className="text-[var(--text-muted)]">
          É especialmente útil quando há queixas de planejamento, dificuldade em tarefas complexas
          do dia a dia ou suspeita de comprometimento com perfil mais executivo — comum em quadros
          vasculares e em fases iniciais de algumas condições neurodegenerativas. Também é uma
          combinação prática na atenção primária, por exigir pouco tempo adicional de consulta.
        </p>
      </section>

      <section aria-labelledby="substitui-neuropsicologica">
        <h2 id="substitui-neuropsicologica" className="text-2xl mb-5">Aplicar os dois juntos substitui a avaliação neuropsicológica completa?</h2>
        <p className="text-[var(--text-muted)] mb-4"><strong>Não.</strong></p>
        <p className="text-[var(--text-muted)]">
          Mesmo combinados, os dois seguem sendo instrumentos de rastreio breve. Quando há dúvida
          diagnóstica ou necessidade de caracterizar melhor o perfil cognitivo, a avaliação
          neuropsicológica formal continua sendo o padrão de referência — veja também{' '}
          <Link to="/mini-mental-ou-moca" className=" text-[var(--primary)] hover:underline">
            como o Mini Mental se compara ao MoCA
          </Link>.
        </p>
      </section>
    </ArticleLayout>
  );
}
